import React from 'react';
import PropTypes from 'prop-types';

import {
	makeStyles,
	useTheme,
	useMediaQuery,
	Divider
} from '@material-ui/core';

import Constants from "../utils/Constants";
import {isJsonEqual} from "../utils/Json";
import {SmallerTabs, SmallerTab} from "../components/SmallerTabs";
import SubNavigationSelect from "../components/SubNavigationSelect";
import NumberCircle from "../components/NumberCircle";

const styles = makeStyles(theme => ({
	tab: {
		fontWeight: 400
	},

	savedTab: {
		width: theme.spacing(11),

		"&:before": {
			width: 1,
			left: 0,
			content: '""',
			position: "absolute",
			display: "block",
			height: theme.spacing(2.5),
			backgroundColor: theme.palette.primary.darkBlue
		}
	}
}));

const InboxTabs = React.memo(function InboxTabs(props) {
	const classes = styles();
	const theme = useTheme();
	const atLeastSM = useMediaQuery(theme.breakpoints.up("sm"));

	let {selectedTab, tabClicked} = props;

	return atLeastSM ? (
		<React.Fragment>
			<SmallerTabs
				centered
				value={selectedTab}
				indicatorColor="primary"
				onChange={tabClicked}>
				<SmallerTab
					value={Constants.ACTIVITY.STATUSES.NEW.ID}
					className={`${classes.tab}`}
					label={`${Constants.ACTIVITY.STATUSES.NEW.NAME}`} />
				<SmallerTab
					value={Constants.ACTIVITY.STATUSES.FOR_REVIEW.ID}
					className={`${classes.tab}}`}
					label={`${Constants.ACTIVITY.STATUSES.FOR_REVIEW.NAME}`} />
				<NumberCircle className={`${classes.tab}`}/>
				<SmallerTab
					value={Constants.ACTIVITY.STATUSES.ESCALATED.ID}
					className={`${classes.tab}`}
					label={`${Constants.ACTIVITY.STATUSES.ESCALATED.NAME}`} />
				<SmallerTab
					value={Constants.ACTIVITY.STATUSES.RESOLVED.ID}
					className={`${classes.tab}`}
					label={`${Constants.ACTIVITY.STATUSES.RESOLVED.NAME}`} />
				<SmallerTab
					value={Constants.ACTIVITY.CATEGORIES.SAVED.FILTER.ID}
					className={`${classes.tab} ${classes.savedTab}`}
					label={`${Constants.ACTIVITY.CATEGORIES.SAVED.FILTER.NAME}`} />
			</SmallerTabs>
			<Divider />
		</React.Fragment>
	) : (
		<SubNavigationSelect
			items={[{
				label: `${Constants.ACTIVITY.STATUSES.NEW.NAME}`,
				value: Constants.ACTIVITY.STATUSES.NEW.ID
			}, {
				label: `${Constants.ACTIVITY.STATUSES.FOR_REVIEW.NAME}`,
				value: Constants.ACTIVITY.STATUSES.FOR_REVIEW.ID
			}, {
				label: `${Constants.ACTIVITY.STATUSES.ESCALATED.NAME}`,
				value: Constants.ACTIVITY.STATUSES.ESCALATED.ID
			}, {
				label: `${Constants.ACTIVITY.STATUSES.RESOLVED.NAME}`,
				value: Constants.ACTIVITY.STATUSES.RESOLVED.ID
			}, {
				label: `${Constants.ACTIVITY.CATEGORIES.SAVED.FILTER.NAME}`,
				value: Constants.ACTIVITY.CATEGORIES.SAVED.FILTER.ID
			}]}
			value={selectedTab}
			changeHandler={tabClicked}
			title="Signals Status"
			helperText="Select the signals status you'd like to view" />
	);
}, (prevProps, newProps) => {
	// if they're the same, don't re-render (return true)
	return isJsonEqual(prevProps, newProps);
});

InboxTabs.displayName = "InboxTabs";

InboxTabs.propTypes = {
	tabClicked: PropTypes.func.isRequired,
	selectedTab: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

InboxTabs.whyDidYouRender = Constants.ENV.IS_LOCAL;

export default InboxTabs;